const days = ['日', '月', '火', '水', '木', '金', '土']

export const FormatDateTime: React.FC<{
  variant: 'ja' | 'universal'
  date: Date
  omitCurrentYear?: boolean
  omitToday?: boolean
}> = (props) => {
  const offsetFromJST = props.date.getTimezoneOffset() / 60 + 9
  const jstTime = props.date.getTime() + offsetFromJST * 60 * 60 * 1000
  const targetDate = new Date(jstTime)

  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1
  const today = new Date().getDate()

  const y = targetDate.getFullYear()
  const m = targetDate.getMonth() + 1
  const d = targetDate.getDate()
  const day = targetDate.getDay()
  const h = targetDate.getHours()
  const min = targetDate.getMinutes().toString().padStart(2, '0')
  switch (props.variant) {
    case 'ja':
      return (
        <>
          {props.omitCurrentYear && currentYear === y ? '' : `${y}年`}
          {props.omitToday &&
          currentYear === y &&
          currentMonth === m &&
          today === d
            ? '本日'
            : `${m}月${d}日（${days[day]}）`}
          {h}:{min}
        </>
      )
    case 'universal':
      return (
        <>
          {props.omitCurrentYear && currentYear === y ? '' : `${y}/`}
          {m.toString().padStart(2, '0')}/{d.toString().padStart(2, '0')} {h}:
          {min}
        </>
      )
  }
}
